import React, { useState } from 'react';
import { Row } from '@shared/ui/atoms/StructuralLayout';
import TextField from '@shared/ui/atoms/TextField';
import { updateFilteredUsers } from '@features/settings/store/userManagement.duck';
import { useDispatch } from "react-redux";
import { IconTypes } from '@shared/ui/atoms/icon/Icon';

export function UserManagementSearchFilter(props: Props) {
  const [searchParam, setSearchParam] = useState('');
  const dispatch = useDispatch();

  const onSearchChange = (val: string) => {
    setSearchParam(val);
    dispatch(updateFilteredUsers(val));
  }
  return (
    <Row style={{marginBottom: 24}}>
      <TextField onChange={onSearchChange} value={searchParam} label="textinput.search-existing-user" icon={IconTypes.Search} />
    </Row>
  )
}

interface Props {
}
